import React from "react";
import Topnav from "../components/Topnav.js";
import Footer from "../components/Footer.js";
import Linkedin from "../components/Linkedin.js";


const Nouvelles = () => {

    return (
        <div>

            <Topnav />
            <Linkedin />
            <Footer />
        </div>
    )
}

export default Nouvelles;
